// check if there is a localStorage 'prevPage' set
// if no, breadcrumb should just be homepage,
// if yes, check that the the value matches the previous page
// also check that the breadcrumb doesn't already exist on the page (ie, if it was in the url)
// if it does match the previous page, set the breadcrumb to be that value, clear the storage item
// if it doesn't match the previous page, breadcrumb should just be homepage, clear the value

const prevUrl = localStorage.getItem('prevPage')

if (prevUrl) {
  const isReferrer = document.referrer.indexOf(prevUrl) > -1
  const isProduct = window.location.href.includes('products')
  const isBlogs = window.location.href.includes('blogs')
  const isPages = prevUrl.includes('pages')

  const breadcrumbTemplate = isBlogs
    ? 'blogs'
    : isPages
      ? 'pages'
      : 'collections'
  const urlBreadcrumb = document.querySelector('.js-collection-url-breadcrumb')
  const localStorageItemAlreadyOnPage =
    urlBreadcrumb?.href?.indexOf(prevUrl) > -1

  if ((isReferrer && !localStorageItemAlreadyOnPage) || isProduct) {
    document.querySelector('.js-collection-breadcrumb a').href = prevUrl
    document.querySelector('.js-collection-breadcrumb a').innerText = prevUrl
      .replaceAll('-', ' ')
      .replaceAll(`${breadcrumbTemplate}`, '')
      .replaceAll('/', '')
    document
      .querySelector('.js-collection-breadcrumb')
      .classList.remove('hidden')
  }

  // Retain prevPage localStorage when in product page changing variants
  if (!isProduct) {
    localStorage.removeItem('prevPage')
  }
}
